import fr from './partner-fr.json' with { type: 'json' };
import en from './partner-en.json' with { type: 'json' };
export function translatePartner(key, locale) {
    return locale === 'en' ? en[key] : fr[key];
}
//# sourceMappingURL=partner.js.map